import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
// import { environment } from "src/environments/environment";
import { environment } from "src/environments/environment.prod";

export interface ApiImage {
  _id: string;
  name: string;
  url: any;
}

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
  // server: string = "https://sikka.inovantsolutions.com/api/a2";
  // // server: string = "https://sikka.inovantsolutions.com/api/a1";
  // imgurl: string = "https://sikka.inovantsolutions.com/files";
  // // imgurl: string = "https://playsikka.com/files";
  // // server: string = "https://playsikka.com/api/a1";
  server: string = "https://playsikka.com/api/a2";
  imgurl: string = "https://playsikka.com/files";
  url: string = this.server;

  // url=environment.server;
  // imgurl=environment.imgurl;


  // imgurl:string=this.image;
  // url: string = this.server;



  constructor(public http: HttpClient) {

  }

  loginGet(endpoint: string, reqOpts?: any) {
    let headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    };
    return this.http.get(this.url + "/" + endpoint, {
      headers: headers
    });
  }

  getCSV(
    endpoint: string,
    from?: string,
    to?: string
  ): Observable<Blob> {

    const headers = new HttpHeaders({
      userID: localStorage.getItem("userid") || '',
      Authorization: "Bearer " + (localStorage.getItem("token") || ''),
      sikka: "Bearer " + (localStorage.getItem("token") || ''),
      role: localStorage.getItem("role") || '',
    });

    let params: any = {};

    if (from) {
      params.from = from;
    }

    if (to) {
      params.to = to;
    }

    return this.http.get(this.url + "/" + endpoint, {
      headers: headers,
      params: params,
      responseType: 'blob'
    });
  }



  get(endpoint: string, reqOpts?: any) {

    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      sikka: "Bearer " + localStorage.getItem("token"),
      role: localStorage.getItem("role"),
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    };
    return this.http.get(this.url + "/" + endpoint, {
      headers: headers
    });
  }

  getPDF(endpoint: string, reqOpts?: any) {
    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      sikka: "Bearer " + localStorage.getItem("token"),
      role: localStorage.getItem("role"),

      "Content-Type": "application/pdf",
      "Access-Control-Allow-Origin": "*"
    };
    return this.http.get<Blob>(this.url + "/" + endpoint, {
      headers: headers, responseType: 'blob' as 'json'
    });
  }


  post(endpoint: string, body: any, reqOpts?: any) {

    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      sikka: "Bearer " + localStorage.getItem("token"),
      role: localStorage.getItem("role"),
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*"
    };
    return this.http.post(this.url + "/" + endpoint, body, {
      headers: headers
    });
  }

  uploadFile(file) {

    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      inv: "Bearer " + localStorage.getItem("token"),
      // "Content-Type": "application/json",
      // "Access-Control-Allow-Origin": "*"
    };

    const formData = new FormData();
    formData.append("file", file, file.name);
    return this.http.post(`${this.url}/UploadFile`, formData, {
      headers: headers
    });
  }

  uploadImage(blobData, name, ext, ID = null, type = null) {

    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      inv: "Bearer " + localStorage.getItem("token"),
      // "Content-Type": "application/json",
      // "Access-Control-Allow-Origin": "*"
    };

    const formData = new FormData();
    formData.append('file', blobData, `myimage.${ext}`);
    formData.append('name', name);
    formData.append('ID', ID);
    formData.append('type', type);

    return this.http.post(`${this.url}/UploadImage`, formData, {
      headers: headers
    });
  }


  put(endpoint: string, body: any, reqOpts?: any) {
    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      sikka: "Bearer " + localStorage.getItem("token"),


    };
    return this.http.put(this.url + "/" + endpoint, body, {
      headers: headers
    });
  }

  delete(endpoint: string, type = null) {
    let headers = {
      userID: localStorage.getItem("userid"),
      Authorization: "Bearer " + localStorage.getItem("token"),
      sikka: "Bearer " + localStorage.getItem("token"),
      type: type,


    };
    return this.http.delete(this.url + "/" + endpoint, {
      headers: headers
    });
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.http.put(this.url + "/" + endpoint, body, reqOpts);
  }
}
